import React, {Component} from "react";
import {SingleDatePicker} from "react-dates";
import Moment from "moment";
import {_updateEvent} from "../../../../../services/apis/EventServices";

class UpdateEventItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: {
                ...this.props.event,
                time: Moment(this.props.event.time),
                keyword: this.props.event.query.keyword,
            },
            timeFocused: false,

            isUpdating: false,
        };
        this._handleUpdate = this._handleUpdate.bind(this);
        this._handleCloseModal = this._handleCloseModal.bind(this);
    }

    _handleChangeTextForm(field, e) {
        const {value} = e.target;
        this.setState({
            event: {
                ...this.state.event,
                [field]: value,
            },
        })
    }


    _handleOnTimeFocused = () => {
        this.setState(({timeFocused}) => ({
            timeFocused: !timeFocused
        }));
    };

    _handleOnChangeDate = (time) => {
        this.setState({
            event: {
                ...this.state.event,
                time,
            }
        });

    };

    _handleCloseModal() {
        this.props.onCloseModal();
    }

    _handleUpdate(e) {
        e.preventDefault();
        const {onUpdate} = this.props;
        const {_id} = this.props.event;
        const {name, description, time, type, area, url, thumbnail, keyword} = this.state.event;
        const timeFormat = 'DD/MM/YYYY';
        this.setState({

            isUpdating: true,
        });
        _updateEvent({
            name,
            description,
            time: time.format(timeFormat),
            type,
            area,
            url,
            keyword,
            thumbnail,
            gmt: time.utcOffset(),
            timeFormat,
        }, _id).then((result) => {
            const {success, data, message} = result;
            if (success) {
                onUpdate(_id, data);
                this._handleCloseModal();
                this.setState({

                    isUpdating: false,
                })
            } else {
                alert(message);
            }
        }).catch((err) => {
            console.log(err);
        })


    }

    render() {
        const {name, description, type, area, url, keyword, time, thumbnail} = this.state.event;
        const {timeFocused} = this.state;
        return (
            <div className="update-event">
                <form onSubmit={this._handleUpdate}>
                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'name')}
                            className="form-control" value={name}
                            name="name" type="text" placeholder="Name"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'keyword')}
                            className="form-control"
                            value={keyword} name="keyword"
                            type="text" placeholder="Keyword"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'thumbnail')}
                            className="form-control" value={thumbnail} name="thumbnail" type="text"
                            placeholder="Thumbnail URL"/>
                    </div>

                    <div className="form-group">
                        <textarea
                            placeholder="Description"
                            onChange={this._handleChangeTextForm.bind(this, 'description')}
                            value={description} className="form-control" name="description" rows="3"/>
                    </div>

                    <div className="form-group">
                        <SingleDatePicker
                            isOutsideRange={() => false}
                            date={time}
                            focused={timeFocused}
                            onFocusChange={this._handleOnTimeFocused}
                            onDateChange={this._handleOnChangeDate}/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'type')}
                            className="form-control" value={type}
                            name="type" type="text" placeholder="Type"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'area')}
                            className="form-control" value={area}
                            name="area" type="text" placeholder="Area"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'url')}
                            className="form-control" value={url}
                            name="url" type="url" placeholder="URL"/>
                    </div>

                    <div className="form-group">
                        <button className={"btn btn-primary" + (this.state.isUpdating ? " loading" : "")} type="submit"
                                disabled={this.state.isUpdating}>{this.state.isUpdating ? <span
                            className='loading-effect'>↻ </span> : ''}{(this.state.isUpdating) ? 'Please wait' : 'Update'} </button>
                    </div>
                </form>
            </div>
        )
    }
}

export default UpdateEventItem;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/events/EventItem/UpdateEventItem.js